export default __webpack_public_path__ + "static/media/blob1.001e7455.svg";